// extracted by mini-css-extract-plugin
export default {"fullscreen":"ImageItem_fullscreen__5XSMI","tools":"ImageItem_tools__8yyuL"};